import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
export const BackgroundBeams = memo(({
  className
}: {
  className?: string;
}) => {
  const paths = ['M-380 -189C-380 -189 -312 216 152 343C616 470 684 875 684 875', 'M-373 -197C-373 -197 -305 208 159 335C623 462 691 867 691 867'
  // ... keeping first few paths for brevity, full array would be included in production
  ];
  return <div className={cn('absolute h-full w-full inset-0 [mask-size:40px] [mask-repeat:no-repeat] flex items-center justify-center bg-gray-900', className)} data-id="element-273" data-mp="bxhw43acr1rx">
      <svg className="z-0 h-full w-full pointer-events-none absolute" width="100%" height="100%" viewBox="0 0 696 316" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-274" data-mp="ky7mgrgufzy9">
        <path d="M-380 -189C-380 -189 -312 216 152 343C616 470 684 875 684 875" stroke="url(#paint0_radial_242_278)" strokeOpacity="0.05" strokeWidth="0.5" data-id="element-275" data-mp="2mr45b0gzw6sx"></path>
        {paths.map((path, index) => <motion.path key={`path-${index}`} d={path} stroke={`url(#linearGradient-${index})`} strokeOpacity="0.4" strokeWidth="0.5" data-id="element-276" data-mp="1tmcp3x53ml94" data-mpi={index}></motion.path>)}
        <defs data-id="element-277" data-mp="23dqsig06857j">
          {paths.map((path, index) => <motion.linearGradient id={`linearGradient-${index}`} key={`gradient-${index}`} initial={{
          x1: '0%',
          x2: '0%',
          y1: '0%',
          y2: '0%'
        }} animate={{
          x1: ['0%', '100%'],
          x2: ['0%', '95%'],
          y1: ['0%', '100%'],
          y2: ['0%', `${93 + Math.random() * 8}%`]
        }} transition={{
          duration: Math.random() * 10 + 10,
          ease: 'easeInOut',
          repeat: Infinity,
          delay: Math.random() * 10
        }} data-id="element-278" data-mp="27estp2dnerc5" data-mpi={index}>
              <stop stopColor="#1e3a8a" stopOpacity="0" data-id="element-279" data-mp="ey9ju4ltuq7m"></stop>
              <stop stopColor="#1e3a8a" data-id="element-280" data-mp="ezugbzrpcj84"></stop>
              <stop offset="32.5%" stopColor="#1e40af" data-id="element-281" data-mp="tvtkx0fls18i"></stop>
              <stop offset="100%" stopColor="#2563eb" stopOpacity="0" data-id="element-282" data-mp="tsxkn5ga90gw"></stop>
            </motion.linearGradient>)}
          <radialGradient id="paint0_radial_242_278" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(352 34) rotate(90) scale(555 1560.62)" data-id="element-283" data-mp="12vp1jkrxgofx">
            <stop offset="0.0666667" stopColor="#1e3a8a" data-id="element-284" data-mp="1cl056rw1p0wf"></stop>
            <stop offset="0.243243" stopColor="#1e3a8a" data-id="element-285" data-mp="17mf7az49mtb5"></stop>
            <stop offset="0.43594" stopColor="white" stopOpacity="0" data-id="element-286" data-mp="1lmg5g6t5bmmx"></stop>
          </radialGradient>
        </defs>
      </svg>
    </div>;
});
BackgroundBeams.displayName = 'BackgroundBeams';